<template>
  <SMDialog
    :modelValue="modelValue"
    max-width="480px"
    @update:model-value="(v) => { if (!confirmationButtonLoading) $emit('update:model-value', v) }"
  >
    <v-card data-cy="confirmation-dialog">
      <div class="d-flex text-h5 dialog-title justify-space-between px-6 pt-6 pb-2">
        {{ title }}
      </div>
      <v-card-text class="pt-2">
        <slot>
          <span class="text-body-1 text-secondary">{{ body }}</span>
        </slot>
      </v-card-text>
      <v-card-actions class="pb-6 px-6">
        <v-spacer />
        <div class="d-flex justify-end">
          <v-btn
            v-if="cancelButtonLabel"
            class="mr-4 text-lg"
            color="primary"
            variant="text"
            data-test="cancel"
            :disabled="confirmationButtonLoading"
            @click="$emit('update:model-value', false)"
          >
            {{ cancelButtonLabel }}
          </v-btn>
          <v-btn
            v-if="confirmationButtonLabel"
            color="primary"
            variant="elevated"
            class="text-white"
            data-test="confirm"
            :disabled="confirmationButtonDisabled"
            :loading="confirmationButtonLoading"
            data-cy="confirmation-dialog-confirm"
            @click="() => { $emit('confirm'); if (!keepOpenOnConfirm) $emit('update:model-value', false) }"
          >
            {{ confirmationButtonLabel }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </SMDialog>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import SMDialog from '@src/ui/SMDialog/index.vue'

export default defineComponent({
  name: 'SMConfirmationDialog',
  components: {
    SMDialog
  },
  props: {
    title: {
      type: String,
      required: true
    },
    body: {
      type: String,
      default: ''
    },
    confirmationButtonLabel: {
      type: String,
      default: ''
    },
    cancelButtonLabel: {
      type: String,
      default: ''
    },
    modelValue: {
      type: Boolean,
      required: true
    },
    confirmationButtonDisabled: {
      type: Boolean,
      default: false
    },
    confirmationButtonLoading: {
      type: Boolean,
      default: false
    },
    keepOpenOnConfirm: {
      type: Boolean,
      default: false
    }
  }
})
</script>
<style lang="scss" scoped>
.dialog-title {
  word-break: break-word;
}
</style>
